<template>
    <div class="dish-budget-list-page">
        <!-- 修复：使用el-checkbox-group包裹，统一绑定数组 -->
        <div class="yield-checkbox-group">
            <el-checkbox-group v-model="checkedYields" @change="getList">
                <el-checkbox label="1" border>成品率1</el-checkbox>
                <el-checkbox label="2" border>成品率2</el-checkbox>
                <el-checkbox label="3" border>成品率3</el-checkbox>
                <el-checkbox label="4" border>成品率4</el-checkbox>
            </el-checkbox-group>
        </div>

        <!-- 预算列表主体 -->
        <div class="list-container">
            <el-table :data="budgetList" border stripe v-loading="loading" @selection-change="handleSelectionChange"
                style="width: 100%;">
                <el-table-column type="selection" width="55" />
                <el-table-column label="原料名称" prop="ingredientName" align="center" />
                <el-table-column label="需求数量" prop="quantity" align="center" />
                <el-table-column label="单位" prop="unit" align="center" />
                <el-table-column label="预计采购数量" prop="estimated" align="center">
                </el-table-column>
            </el-table>
            <!-- 分页 -->
            <div class="pagination-container">
                <el-pagination @size-change="handleSizeChange" @current-change="handleCurrentChange"
                    :current-page="pagination.pageNum" :page-sizes="[10, 20, 50, 100]" :page-size="pagination.pageSize"
                    layout="total, sizes, prev, pager, next, jumper" :total="pagination.total"
                    style="margin-top: 20px; text-align: right;">
                </el-pagination>
            </div>
        </div>
    </div>
</template>

<script>
import { budget } from "@/api/budget";
export default {
    data() {
        return {
            // 成品率勾选状态（数组存储选中值）
            checkedYields: [],
            // 加载状态
            loading: false,
            // 筛选条件
            searchForm: {
                budgetName: '',
                budgetDate: '',
                status: '',
                peopleCount: ''
            },
            // 选中的行（批量操作）
            selectedRows: [],
            // 预算列表数据
            budgetList: [],
            // 分页参数
            pagination: {
                pageNum: 1,
                pageSize: 10,
                total: 0
            }
        };
    },
    created() {
        this.getList()
    },
    methods: {
        // 封装参数转换方法
        getYieldParams() {
            const params = {
                // 确认数组中是否包含对应字符串值
                param1: this.checkedYields.includes('1') ? 1 : 0,
                param2: this.checkedYields.includes('2') ? 1 : 0,
                param3: this.checkedYields.includes('3') ? 1 : 0,
                param4: this.checkedYields.includes('4') ? 1 : 0
            };
            console.log('当前勾选值：', this.checkedYields); // 调试：看选中的值是否正确
            console.log('生成的成品率参数：', params);
            return params;
        },
        // 获取列表数据（主方法）
        getList() {
            this.loading = true;
            // 整合所有参数（成品率 + 分页）
            const requestParams = {
                ...this.getYieldParams(),
                // pageNum: this.pagination.pageNum,  // 补充分页参数（GET请求必须传）
                // pageSize: this.pagination.pageSize
            };
            budget(requestParams).then(response => {
                console.log('接口返回数据：', response);
                this.budgetList = response.data || [];
                this.pagination.total = response.total || 0;
                this.loading = false;
            }).catch(error => {
                console.error('获取列表失败：', error);
                this.budgetList = [];
                this.pagination.total = 0;
                this.loading = false;
            });
        },
        // 分页：每页条数改变
        handleSizeChange(val) {
            this.pagination.pageSize = val;
            this.getList();
        },
        // 分页：当前页改变
        handleCurrentChange(val) {
            this.pagination.pageNum = val;
            this.getList();
        },
        // 新增预算
        goToAdd() {
            this.$router.push('/dish-budget/add');
        },
        // 查看详情
        viewDetail(row) {
            this.$router.push(`/dish-budget/detail/${row.id}`);
        },
        // 批量选择行事件
        handleSelectionChange(val) {
            this.selectedRows = val;
        }
    }
};
</script>

<style lang="scss" scoped>
.dish-budget-list-page {
    width: 100%;
    min-height: 100vh;
    padding: 20px;
    box-sizing: border-box;
    background-color: #f5f7fa;

    // 成品率勾选框样式
    .yield-checkbox-group {
        display: flex;
        gap: 20px;
        padding: 15px;
        margin-bottom: 15px;
        background-color: #fff;
        border-radius: 8px;
        box-shadow: 0 2px 8px rgba(0, 0, 0, 0.05);

        .el-checkbox {
            font-size: 14px;
            color: #333;
        }
    }

    // 列表容器
    .list-container {
        background-color: #fff;
        padding: 20px;
        border-radius: 8px;
        box-shadow: 0 2px 12px rgba(0, 0, 0, 0.05);

        .pagination-container {
            padding-top: 10px;
            border-top: 1px solid #e6e6e6;
        }
    }
}

// 响应式适配
@media (max-width: 1200px) {
    .dish-budget-list-page {
        padding: 10px;

        .yield-checkbox-group {
            flex-wrap: wrap;
            gap: 10px;
            padding: 10px;
        }
    }
}
</style>